
import { Card, CardContent } from '@/components/ui/card';
import { simplifyProviderName } from '@/components/admin/peo/utils/nameUtils';
import { PEOProviderCardProps } from './types';
import { CardHeader } from './CardHeader';
import { CardActions } from './CardActions';
import { EmployeeInfo } from './EmployeeInfo';
import { Capabilities } from './Capabilities';
import { CarveOuts } from './CarveOuts';
import { Specialties } from './Specialties';

export const PEOProviderCard = ({
  provider,
  isPreferred,
  isExcluded,
  onTogglePreferred,
  onToggleExcluded,
}: PEOProviderCardProps) => {
  // Use the updated simplifyProviderName utility
  const displayName = simplifyProviderName(provider.name);
  
  return (
    <Card className="relative transition-all duration-200 hover:shadow-md border border-primary/10 overflow-hidden">
      <div className={`absolute inset-x-0 h-1 top-0 ${isPreferred ? 'bg-primary' : isExcluded ? 'bg-red-500' : 'bg-gray-200'}`}></div>
      <CardContent className="p-6">
        <CardActions 
          isPreferred={isPreferred}
          isExcluded={isExcluded}
          onTogglePreferred={onTogglePreferred}
          onToggleExcluded={onToggleExcluded}
          providerName={provider.name}
        />

        <div className="space-y-3 pr-16">
          <CardHeader displayName={displayName} provider={provider} />
          
          <EmployeeInfo provider={provider} />
          
          <Capabilities provider={provider} />
          
          <CarveOuts provider={provider} />
          
          <Specialties specialties={provider.specialties} />
        </div>
      </CardContent>
    </Card>
  );
};
